// test1182
(1182 && 0);
